<template>
  <sfs-form-modal
    :id="modalId"
    :title="modalTitle"
    @on-hide="resetForm"
  >
    <b-form
      novalidate
      @submit.stop.prevent="handleSubmit"
    >
      <b-row>
        <b-col>
          <b-alert
            :show="baseServerErrors.length > 0"
            variant="danger"
            dismissible
            @dismissed="baseServerErrors = []"
          >
            <p
              class="mb-0"
              v-for="(error, index) in baseServerErrors"
              :key="index"
            >
              {{ error }}
            </p>
          </b-alert>
        </b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col cols="12">
          <b-alert
            show
            variant="info"
            class="mb-0"
          >
            Undoing work order check-in / out will be processed in the background. You can continue working while it finishes.
          </b-alert>
        </b-col>
      </b-row>

      <b-row
        v-if="ineligibleWorkOrders.length"
        class="mb-2"
      >
        <b-col>
          <b-alert
            show
            variant="warning"
          >
            The selected Work Orders can't have check-in / out undone and will be skipped:
            {{ ineligibleWorkOrders.map((wo) => wo.number || `#${wo.id}`).join(', ') }}
          </b-alert>
        </b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col>
          Check-in and check-out will be cleared, and eligible Work Orders will return to assigned.
        </b-col>
      </b-row>

      <hr class="mt-4">

      <b-row>
        <b-col
          offset-lg="6"
          lg="3"
          order="2"
          order-lg="1"
        >
          <b-button
            variant="link-dark"
            block
            id="work-order-undo-completion-close-button"
            @click="closeModal"
          >
            Cancel
          </b-button>
        </b-col>
        <b-col
          lg="3"
          order="1"
          order-lg="2"
        >
          <b-button
            id="work-order-undo-completion-submit-button"
            block
            type="submit"
            variant="primary"
            :disabled="processing || !eligibleWorkOrders.length"
          >
            Undo
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </sfs-form-modal>
</template>

<script>
import errorToastMixin from '@/mixins/errorToastMixin';

export default {
  name: 'WorkOrdersUndoCompletionModal',
  mixins: [errorToastMixin],
  props: {
    workOrders: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      modalId: 'work-order-undo-completion-modal',
      baseServerErrors: [],
      processing: false,
    };
  },
  computed: {
    modalTitle() {
      return `Undo Check-In / Out for ${this.eligibleWorkOrders.length} Work Orders`;
    },
    eligibleWorkOrders() {
      return this.workOrders.filter((workOrder) => this.$can('undo_completion', workOrder));
    },
    ineligibleWorkOrders() {
      return this.workOrders.filter((workOrder) => !this.$can('undo_completion', workOrder));
    },
  },
  methods: {
    async handleSubmit() {
      this.baseServerErrors = [];

      if (!this.eligibleWorkOrders.length) {
        return;
      }

      this.processing = true;
      try {
        const response = await this.$workOrdersAPI.bulkUndoCompletionWorkOrders({}, this.buildPayload());
        this.showBackgroundProcessingToast();
        this.$emit('undone', response);
        this.closeModal();
      } catch (error) {
        await this.processServerErrors(error);
      } finally {
        this.processing = false;
      }
    },
    buildPayload() {
      return {
        work_order_ids: this.eligibleWorkOrders.map((workOrder) => Number(workOrder.id)),
      };
    },
    async processServerErrors(error) {
      const message = await this.extractErrorMessage(error, 'Unable to undo work order completion.');
      this.baseServerErrors = [message];
    },
    showBackgroundProcessingToast() {
      if (!this.$bvToast) {
        return;
      }

      this.$bvToast.toast('Work order check-in / out is being undone in the background.', {
        title: 'Undo queued',
        toaster: 'b-toaster-bottom-right',
        variant: 'info',
        autoHideDelay: 5000,
        appendToast: false,
      });
    },
    resetForm() {
      this.baseServerErrors = [];
      this.processing = false;
    },
    closeModal() {
      this.resetForm();
      this.$bvModal.hide(this.modalId);
    },
  },
};
</script>
